<div class="sms-counter" *ngIf="message" [ngClass]="statusClass">
  <!-- Contador principal -->
  <div class="counter-main">
    <i class="pi" [ngClass]="statusIcon"></i>
    <span class="count">{{ sanitizedLength }} / {{ MAX_LENGTH }}</span>
    <span class="remaining" *ngIf="!wasTruncated">{{ remainingChars }} restantes</span>
  </div>
  
  <!-- Advertencia de truncado -->
  <div class="truncate-warning" *ngIf="wasTruncated">
    <i class="pi pi-times-circle"></i>
    <div>
      <strong>¡Mensaje será truncado automáticamente!</strong>
      <small>El texto excede 160 caracteres. Se enviará solo la primera parte.</small>
    </div>
  </div>
  
  <!-- Indicador de sanitización -->
  <div class="sanitize-info" *ngIf="wasSanitized && !wasTruncated">
    <i class="pi pi-info-circle"></i>
    <div>
      <small>
        <strong>Caracteres sanitizados:</strong> 
        <span class="char-list">{{ incompatibleChars.join(', ') }}</span>
      </small>
      <small class="help-text">Las tildes, emojis y caracteres especiales se convertirán automáticamente.</small>
    </div>
  </div>
  
  <!-- Advertencia cerca del límite -->
  <div class="near-limit-warning" *ngIf="!wasTruncated && sanitizedLength > MAX_LENGTH * 0.9">
    <i class="pi pi-exclamation-circle"></i>
    <small>Quedan solo {{ remainingChars }} caracteres disponibles</small>
  </div>
  
  <!-- Preview del mensaje sanitizado (solo si hay cambios) -->
  <div class="sanitized-preview" *ngIf="wasSanitized && message !== sanitizedMessage">
    <div class="preview-header">
      <i class="pi pi-eye"></i>
      <strong>Mensaje que se enviará:</strong>
    </div>
    <div class="preview-text">{{ sanitizedMessage }}</div>
  </div>
</div>
